import { render, staticRenderFns } from "./e-text-with-icon.vue?vue&type=template&id=ad2b6708&scoped=true&lang=pug&"
import script from "./e-text-with-icon.vue?vue&type=script&lang=js&"
export * from "./e-text-with-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2b6708",
  null
  
)

export default component.exports